export const email = 'test@test.com'
export const password = 'test123'
export const connection = {
  name: 'payloadmemory',
  port: 27018,
  url: 'mongodb://127.0.0.1',
}
